function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { cn } from "../../lib/utils";
import { cva } from 'class-variance-authority';
import { jsx as _jsx } from "react/jsx-runtime";
var Ball = function Ball(props) {
  var buttonVariants = cva('', {
    variants: {
      size: {
        large: 'h-16 w-16',
        medium: 'h-12 w-12',
        small: 'h-8 w-8'
      }
    },
    defaultVariants: {
      size: 'medium'
    }
  });
  var _ref = props !== null && props !== void 0 ? props : {},
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size;
  return /*#__PURE__*/_jsx("div", _objectSpread({
    className: cn('animate-pulse rounded-full bg-base-bds-trans-hover', buttonVariants({
      size: size
    }), className)
  }, props));
};
var Bar = function Bar(props) {
  var _ref2 = props !== null && props !== void 0 ? props : {},
    className = _ref2.className,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'medium' : _ref2$size;
  var buttonVariants = cva('', {
    variants: {
      size: {
        'xx-large': 'h-12',
        'x-large': 'h-8',
        large: 'h-6',
        medium: 'h-[18px]',
        small: 'h-3.5'
      }
    },
    defaultVariants: {
      size: 'medium'
    }
  });
  return /*#__PURE__*/_jsx("div", _objectSpread({
    className: cn('animate-pulse rounded-lg w-full bg-base-bds-trans-hover', buttonVariants({
      size: size
    }), className)
  }, props));
};
var Bars = function Bars(props) {
  var _ref3 = props !== null && props !== void 0 ? props : {},
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'medium' : _ref3$size,
    _ref3$row = _ref3.row,
    row = _ref3$row === void 0 ? 6 : _ref3$row;
  return /*#__PURE__*/_jsx("div", {
    className: "space-y-4",
    children: new Array(Number(row)).fill(undefined).map(function (_, index) {
      return /*#__PURE__*/_jsx(Bar, {
        size: size,
        style: {
          width: "".concat(Math.floor(Math.random() * (100 - 50) + 50), "%")
        }
      }, index);
    })
  });
};
var Skeleton = {
  Ball: Ball,
  Bar: Bar,
  Bars: Bars
};
export { Skeleton };